module.exports = __webpack_public_path__ + "img/relacionescolor-hipra.ee5d2209.png";